// extracted by mini-css-extract-plugin
export default {"root":"_2HbRB","earnings":"_3n-No","info-icon":"_25NC4","infoIcon":"_25NC4"};